var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "priceView" }, [
    _c("div", { staticClass: "priceUnit" }, [_vm._v("￥")]),
    _c("div", { staticClass: "priceText" }, [
      _vm._v(_vm._s(_vm.renderValue())),
    ]),
    _c("div", { staticClass: "priceDecimal" }, [
      _vm._v(_vm._s(_vm.renderDecimal())),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }